import { Dialog } from '@ori-ui/components';
import { CircularProgress } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

export const WizardLoader: FC = () => {
  const { getTestIdProps } = useTestId();

  return (
    <Dialog
      open
      hideCloseButton
      {...getTestIdProps('wizard-loader')}
    >
      <div style={{ display: 'grid', alignItems: 'center', justifyItems: 'center', height: '100%' }}>
        <CircularProgress />
      </div>
    </Dialog>
  );
};
